module.exports = __webpack_public_path__ + "static/media/video.507d9b07.mp4";